import { customily2StoreTypes } from '@/typings/storeType';
import type { CustomilyUser } from '@/typings/user';

// Single source of truth for "where is Home for this user", shared by real sign-in
//  (appCtrl.js's redirectToHome) and post-impersonate navigation (sidebarWrapperCtrl.js),
//  which can't reuse $rootScope state because it needs a full page reload.
// forceHome mirrors appCtrl.js's original `flag` param: skips the collective-retail/C2-store
//  branching and goes straight to '/home', but the affiliate override still wins over it.
export function getHomeRedirectPath(user?: CustomilyUser, forceHome = false): string {
    const roles: string[] = user?.AccessRoles?.Serialized?.split(',') || [];

    if (roles.includes('affiliate') && !roles.includes('admin') && !user?.ImpersonatedFromAdminUser) {
        return '/affiliates';
    }

    if (forceHome) {
        return '/home';
    }

    if (roles.includes('collective-retail')) {
        return '/store/products';
    }

    const hasC2Store = user?.Stores?.some((s) => customily2StoreTypes.includes(s.Type));
    return hasC2Store ? '/store/podSelection' : '/home';
}
